
import { Site } from "@/services/types";

export const useSiteUtils = () => {
  // Format opening hours for display
  const formatOpeningHours = (site: Site) => {
    if (!site.opening_hours) return "Horaires non disponibles";
    
    const days = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
    let formattedHours = "";
    
    days.forEach(day => {
      if (site.opening_hours[day]) {
        const dayHours = site.opening_hours[day];
        if (dayHours.matin === "Fermé" && dayHours.apres_midi === "Fermé") {
          formattedHours += `${day.charAt(0).toUpperCase() + day.slice(1)}: Fermé\n`;
        } else {
          formattedHours += `${day.charAt(0).toUpperCase() + day.slice(1)}: ${dayHours.matin}, ${dayHours.apres_midi}\n`;
        }
      }
    });
    
    return formattedHours;
  };

  // Get site path for navigation
  const getSitePath = (site: Site) => {
    return `/${site.id}`;
  };

  // Get directions URL
  const getDirectionsUrl = (site: Site) => {
    if (site.name === "SAS Bellé recyclage") {
      return `https://www.google.com/maps/search/?api=1&query=Camp+Franc+9J7M%2BHX+Sainte-Radegonde`;
    } else if (site.name === "Centre de Briane Jean Récupération" || site.name === "Briane Jean Récupération") {
      return `https://www.google.com/maps/search/?api=1&query=Le+Pré+de+Bouques+12170+Lédergues`;
    } else if (site.name === "Fabrude Recyclage") {
      return `https://www.google.com/maps/search/?api=1&query=Prentegarde,+D120,+15250+Saint-Paul-des-Landes`;
    } else if (site.name === "Lescout Recyclage") {
      return `https://g.co/kgs/W73veAx`;
    } else if (site.name === "RM Recyclage") {
      return `https://www.google.com/maps/search/?api=1&query=45.06536,3.11071`;
    }
    // Default to coordinates
    return `https://www.google.com/maps?q=${site.coordinates.lat},${site.coordinates.lng}`;
  };

  return {
    formatOpeningHours,
    getDirectionsUrl,
    getSitePath,
  };
};
